export default "__VITE_ASSET__L3nACk4h__"